import React from 'react';

import { Chip } from '@/comp';
import { LifetimeSavingsContainer } from '@/comp/pages/ValueDashboardPage/EnergySavings/styled';

import Co2Saving from './Co2Saving';
import { Skeleton } from 'antd';

interface LifetimeSavingsProps {
  loading: boolean;
  title: string;
  displayPercentage?: boolean;
  percentageText?: string;
  displayPower?: boolean;
  powerText?: string;
  displayItemChip?: boolean;
  chipText?: string;
  displayCo2Saving?: boolean;
  co2SavingValue?: string;
}

const LifetimeSavings = ({
  loading,
  title,
  displayPercentage = false,
  percentageText,
  displayPower,
  powerText,
  displayItemChip,
  chipText,
  displayCo2Saving,
  co2SavingValue,
}: LifetimeSavingsProps) => {
  return (
    <LifetimeSavingsContainer>
      <span className={'lifetime-label title'}>{title}</span>
      <Skeleton
        active
        paragraph={false}
        title={{ width: 200 }}
        rootClassName="lifetime-savings-skeleton"
        loading={loading}
      >
        {displayPercentage && <div className={'lifetime-label percentage'}>{percentageText}</div>}
        {displayPower && <span className={'lifetime-label power'}>{powerText}</span>}
        {displayItemChip && (
          <span className="lifetime-label legend-item-chip">
            <Chip className={'saving-chip'} title={chipText} />
          </span>
        )}
        {displayCo2Saving && (
          <span className={'lifetime-label flex-container'}>
            <Co2Saving savingValue={co2SavingValue} />
          </span>
        )}
      </Skeleton>
    </LifetimeSavingsContainer>
  );
};

export default LifetimeSavings;
